import type { ReactNode } from 'react';
import styled from 'styled-components';
import { FontLineHeightNormal } from 'autogen/design-tokens/tokens';
import type { ProductNameLine } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import { verticalEllipsis } from 'modules/helpers/mixins';
import { Variant } from '../shared/styles';
import type { IProductName } from '../shared/types';

const StyledTypographyBody = styled(Typography.Body)`
    ${verticalEllipsis(1)}

    span {
        line-height: ${FontLineHeightNormal};
    }
`;

const StyledVariant = styled(Variant)`
    display: block;
    ${verticalEllipsis(1)}
`;

const compactNameRenderer = (
    line: ProductNameLine,
    strongProductTitle: IProductName['strongProductTitle']
): JSX.Element | ReactNode => {
    const { type, value } = line;

    switch (type) {
        case 'Variant':
        case 'Color':
        case 'Size':
            return (
                <StyledVariant key={value} forwardedAs="span" size="S">
                    {value}
                </StyledVariant>
            );
        default:
            return (
                <StyledTypographyBody key={value} forwardedAs="span" size="M" strong={strongProductTitle}>
                    {value}
                </StyledTypographyBody>
            );
    }
};

export default compactNameRenderer;
